import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MainPage from "./pages/MainPage";
import AboutPage from "./pages/AboutPage";

const App = () => {
  return (
    <Router>
    


      <nav className="p-4 bg-gray-100 mb-4 flex items-center gap-3">
        <Link to="/" className="text-blue-600 flex items-center gap-1">
          🏠 <span>Home</span>
        </Link>
        <Link to="/about" className="text-blue-600 flex items-center gap-1">
          📣 <span>About / Feedback</span>
        </Link>
        <a
          href="mailto:bricahoranad@gmail.com"
          className="text-blue-600 flex items-center gap-1"
        >
          ✉️ <span>Contact Me</span>
        </a>
        

      </nav>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
};

export default App;
